import { z } from "zod";
import { EventDataSourceImported } from "./data-source-imported";
import { EventVersionReleased } from "./version-released";
import { EventDocumentationPublished } from "./documentation-published";

export const Event = z.discriminatedUnion("type", [
  EventVersionReleased,
  EventDataSourceImported,
  EventDocumentationPublished,
]);

export type Event = z.infer<typeof Event>;
